"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerationRulesService = void 0;
var performerBanRule_1 = require("./rules/performerBanRule");
var blockPatternRule_1 = require("./rules/blockPatternRule");
var mediafilePatternRule_1 = require("./rules/mediafilePatternRule");
var GenerationRulesService = (function () {
    function GenerationRulesService(mediafileBlocks) {
        this.mediafileBlocks = mediafileBlocks;
    }
    GenerationRulesService.prototype.checkRules = function (_a) {
        var mediafile = _a.mediafile, blockIds = _a.blockIds, tagPatterns = _a.tagPatterns, bannedPerformers = _a.bannedPerformers;
        if ((0, performerBanRule_1.performerBanRule)(bannedPerformers, mediafile.performerTitle)) {
            return { check: false };
        }
        var blockId = (0, blockPatternRule_1.blockPatternRule)(mediafile.id, blockIds, this.mediafileBlocks);
        if (!blockId) {
            return {
                check: false,
                performer: mediafile.performerTitle,
            };
        }
        var tagPattern = tagPatterns[blockId];
        if (!tagPattern) {
            return {
                check: false,
                blockId: blockId,
                performer: mediafile.performerTitle,
            };
        }
        var tags = tagPattern.pattern[tagPattern.index];
        if (!(tags === null || tags === void 0 ? void 0 : tags.length)) {
            return {
                check: true,
                blockId: blockId,
                performer: mediafile.performerTitle,
            };
        }
        var tagId = (0, mediafilePatternRule_1.mediafilePatternRule)(mediafile.aggregateValues, tags);
        if (!tagId) {
            return {
                check: false,
                blockId: blockId,
                performer: mediafile.performerTitle,
            };
        }
        return {
            check: true,
            blockId: blockId,
            tagId: tagId,
            performer: mediafile.performerTitle,
        };
    };
    return GenerationRulesService;
}());
exports.GenerationRulesService = GenerationRulesService;
//# sourceMappingURL=index.js.map